<template>
    <v-card>
        <v-form
            ref="entityForm"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredRule,lengthRule(50)]"
                                label="Name"
                                v-model="entity.name"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :disabled="isLoading"
                                :rules="[requiredPositiveNumber]"
                                label="Code"
                                min="0"
                                type="number"
                                v-model.number="entity.code"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="subscriptions"
                                :rules="[requiredRule]"
                                item-text="value"
                                item-value="key"
                                label="Subscription"
                                v-model="entity.subscriptionId"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :disabled="isLoading"
                                :items="representatives"
                                :rules="[requiredRule]"
                                item-text="value"
                                item-value="key"
                                label="Representative"
                                v-model="entity.representativeId"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="space-between"
                        no-gutters
                    >
                        <v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="entity.id > 0"
                        >Delete</v-btn>
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                        <v-btn
                            :disabled="isLoading && !isSaving"
                            :loading="isSaving"
                            @click="saveEntity"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >{{entity.id > 0 ? "Update" : "Add"}}</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
import RepresentativeProduct from "../../models/RepresentativeProduct.model";
export default {
    props: {
        entityIn: RepresentativeProduct
    },
    components: {
        //representatives
    },
    mounted: async function() {
        this.representatives = await this.$store.dispatch(
            "representatives/getlist"
        );
        this.subscriptions = await this.$store.dispatch(
            "subscriptions/getlist"
        );
    },
    data() {
        return {
            representatives: [],
            subscriptions: [],
            entity: new RepresentativeProduct().set(this.entityIn),
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredPositiveNumber: v =>
                (v != null && !isNaN(v) && v > 0) || "required positive number",
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },

    methods: {
        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedEntity) {
            this.$emit("saved", savedEntity);
        },
        emitDeletedEntity(deletedEntity) {
            this.$emit("deleted", deletedEntity);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.$refs.entityForm.validate();
        },
        //save      ------------------------------------------------------------
        saveEntity() {
            this.validateForm();
            if (this.isValid) {
                this.isLoading = true;
                this.isSaving = true;

                this.$store
                    .dispatch(
                        "representativeProducts/" +
                            (this.entity.id == 0 ? "create" : "update"),
                        this.entity
                    )
                    .then(
                        entityWithInfo => {
                            this.notify("Successfully saved.", "success");
                            if (this.entity.id == 0) {
                                this.entity.id = entityWithInfo.entity.id;
                            }
                            this.emitSavedEntity(entityWithInfo);
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.saveEntityDone);
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm("Are you sure you want to delete this?");
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("representativeProducts/delete", this.entity.id)
                    .then(
                        () => {
                            this.notify("Successfully deleted.", "success");
                            this.emitDeletedEntity(this.entity);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        }
    }
};
</script>

<style lang="stylus" scoped></style>